export const environment = {
  COMPANYID: "MTczNDE=",
  COMPANYURL: "ZnRkaW5kaWEucHJlcHJvZDEub3BlbmluZ3MuY28vL21hbmFnZQ==",
  DOMAIN: "ftdindia.preprod1.openings.co",
  APIENDPOINT: "https://apipreprod1.zwayam.com/",
  APIENDPOINTNEW: "https://apipreprod1.zwayam.com/",
  JOBSHAREURL: "https://apipreprod1.zwayam.com",
  TENANTAPIURL : "https://apipreprod1.zwayam.com"
};